import {ADD_BACKGROUND, DELETE_BACKGROUND, GET_BACKGROUND} from "./actions.type";
import {backgroundService} from "../service/backgroundService";

function initState() {
    return {
        list: []
    }
}

const state = initState();

const actions = {
    // eslint-disable-next-line no-empty-pattern
    async [GET_BACKGROUND]({commit}) {
        let data = await backgroundService.getBackground();
        commit(GET_BACKGROUND, data);
    },

    // eslint-disable-next-line no-empty-pattern
    async [DELETE_BACKGROUND]({}, id) {
        return await backgroundService.deleteBackground(id);
    },

    // eslint-disable-next-line no-empty-pattern
    async [ADD_BACKGROUND]({}, data) {
        return await backgroundService.addBackground(data);
    }
};

const mutations = {

    [GET_BACKGROUND](state, data) {
        state.list = data;
    },

};

const getters = {};

export default {
    state,
    actions,
    mutations,
    getters
};
